import { Filter } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import { Button } from '@/shared/components/ui/Button';

interface FilteredViewBannerProps {
  signalCount: number;
}

export const FilteredViewBanner = ({
  signalCount,
}: FilteredViewBannerProps) => {
  const { t } = useTranslation('knowledge');
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-2 rounded-lg bg-muted px-3 py-2">
      <Filter className="h-4 w-4 text-muted-foreground" />
      <span className="text-sm text-muted-foreground">
        {t('viewingFilteredSignals')(signalCount)}
      </span>
      <Button
        variant="ghost"
        size="sm"
        className="h-auto py-1"
        onClick={() =>
          navigate({
            to: '/knowledge',
            search: { signalIds: undefined },
          })
        }
      >
        {t('viewAllSignals')}
      </Button>
    </div>
  );
};
